export enum UsersTabsEnum {
  INVITED = 'invited',
  SUBSCRIBED = 'subscribed',
}
export interface ReferralsUsersProps {
  tab: UsersTabsEnum;
}
